module.exports = __webpack_public_path__ + "static/media/filter.34b5b667.svg";